import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function PriceCalculatorEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function PriceCalculatorCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"price calculator"} children={children} />
    );
}